import { writable } from "svelte/store";

export const SqPayment = writable(null);

export const parentElement = writable("");

export const step = writable(1);

export const book = writable({
  date: "",
  location: "",
  locationName: "",
  locationCountry: "",
  timeslot: "",
  admission: "",
  length: "",
  type: "",
  subtype: "",
  duration: 0,
  admissions: [],
  timeslots: [],
  customer: {
    fullName: "",
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
  },
  paymentProcessed: false,
});

export const bookingConfirmation = writable({
  reference: "",
  secureToken: ""
});
